export default "__VITE_ASSET__77a5ba45__"